/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import dayjs from "dayjs";

export function getWeekRange(date: Date) {
  const start = dayjs(date).startOf("isoWeek").toISOString();
  const end = dayjs(date).endOf("isoWeek").toISOString();

  return {
    start,
    end,
  };
}

export function getDefaultTimeRange() {
  const now = dayjs();

  const timeSlot = Math.floor(now.hour() / 6);

  switch (timeSlot) {
    case 0:
      return {
        start: now.startOf("day").toISOString(),
        end: now.startOf("day").hour(6).toISOString(),
      };
    case 1:
      return {
        start: now.startOf("day").hour(6).toISOString(),
        end: now.startOf("day").hour(12).toISOString(),
      };
    case 2:
      return {
        start: now.startOf("day").hour(12).toISOString(),
        end: now.startOf("day").hour(18).toISOString(),
      };
    case 3:
      return {
        start: now.startOf("day").hour(18).toISOString(),
        end: now.endOf("day").toISOString(),
      };
    default:
      throw new Error(
        `Unsupported time slot: ${now.toISOString()} ${timeSlot}`
      );
  }
}
